/*
 * Members Only password gate.
 *
 * Hashes what the visitor types and compares it against the hash Liquid printed
 * on the gate element, so the code itself never appears in the page source.
 * Both sides are downcased before hashing, which is what makes the match
 * case-insensitive.
 */
(function () {
  var gate = document.querySelector('[data-mo-gate]');
  if (!gate) return;

  var form = gate.querySelector('[data-mo-form]');
  var input = gate.querySelector('[data-mo-input]');
  var error = gate.querySelector('[data-mo-error]');
  var button = gate.querySelector('[data-mo-submit]');

  var expected = gate.dataset.moHash;
  var days = parseInt(gate.dataset.moDays, 10) || 30;

  function sha256(value) {
    var bytes = new TextEncoder().encode(value);
    return crypto.subtle.digest('SHA-256', bytes).then(function (buffer) {
      return Array.from(new Uint8Array(buffer))
        .map(function (b) { return b.toString(16).padStart(2, '0'); })
        .join('');
    });
  }

  function unlock() {
    try {
      localStorage.setItem('mo_unlocked', JSON.stringify({
        hash: expected,
        expires: Date.now() + days * 24 * 60 * 60 * 1000
      }));
    } catch (e) {
      /* Private browsing can block writes. The visitor still gets in for this
         page view, they will just be asked again on the next one. */
    }
    document.documentElement.classList.remove('mo-locked');
    document.documentElement.classList.add('mo-unlocked');
  }

  function fail() {
    error.hidden = false;
    gate.classList.add('mo-gate--error');
    input.setAttribute('aria-invalid', 'true');
    input.focus();
    input.select();
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var entered = (input.value || '').trim().toLowerCase();
    if (!entered) return fail();

    button.disabled = true;

    sha256(entered)
      .then(function (hash) {
        if (hash === expected) {
          unlock();
        } else {
          fail();
        }
      })
      .catch(fail)
      .then(function () {
        button.disabled = false;
      });
  });

  input.addEventListener('input', function () {
    error.hidden = true;
    gate.classList.remove('mo-gate--error');
    input.removeAttribute('aria-invalid');
  });

  if (document.documentElement.classList.contains('mo-locked')) {
    input.focus();
  }
})();
